export const FAA_LANDING_PAGE_MODULE = {
  CONTENT_CAROUSEL_GUIDES: 'Content Carousel - Guides',
  CTA_DRIVER_GET_APPRAISAL: 'CTA Driver - Get an Appraisal',
  CTA_DRIVER_TRACK_HOME: 'CTA Driver - Track Home',
  CTA_DRIVER_RECENTLY_SOLD: 'CTA Driver - Recently Sold',
  SUBURB_SNAPSHOT: 'Suburb Snapshot',
} as const;

export type FaaLandingPageModule =
  (typeof FAA_LANDING_PAGE_MODULE)[keyof typeof FAA_LANDING_PAGE_MODULE];

interface LandingPageModuleVisibility {
  hasContentCarouselGuides?: boolean;
  hasCtaDriverGetAppraisal?: boolean;
  hasCtaDriverTrackHome?: boolean;
  hasCtaDriverRecentlySold?: boolean;
  hasSuburbSnapshot?: boolean;
}

const defaultVisibility: Required<LandingPageModuleVisibility> = {
  hasContentCarouselGuides: true,
  hasCtaDriverGetAppraisal: true,
  hasCtaDriverTrackHome: true,
  hasCtaDriverRecentlySold: true,
  hasSuburbSnapshot: false,
};

export const getVisibleLandingPageModules = (
  visibility: LandingPageModuleVisibility = {},
): FaaLandingPageModule[] => {
  const resolvedVisibility = {
    ...defaultVisibility,
    ...visibility,
  };

  const modules: FaaLandingPageModule[] = [];

  if (resolvedVisibility.hasContentCarouselGuides) {
    modules.push(FAA_LANDING_PAGE_MODULE.CONTENT_CAROUSEL_GUIDES);
  }

  if (resolvedVisibility.hasCtaDriverGetAppraisal) {
    modules.push(FAA_LANDING_PAGE_MODULE.CTA_DRIVER_GET_APPRAISAL);
  }

  if (resolvedVisibility.hasCtaDriverTrackHome) {
    modules.push(FAA_LANDING_PAGE_MODULE.CTA_DRIVER_TRACK_HOME);
  }

  if (resolvedVisibility.hasCtaDriverRecentlySold) {
    modules.push(FAA_LANDING_PAGE_MODULE.CTA_DRIVER_RECENTLY_SOLD);
  }

  if (resolvedVisibility.hasSuburbSnapshot) {
    modules.push(FAA_LANDING_PAGE_MODULE.SUBURB_SNAPSHOT);
  }

  return modules;
};
